import { render, staticRenderFns } from "./StaffListItem.vue?vue&type=template&id=089851c2&"
import script from "./StaffListItem.vue?vue&type=script&lang=js&"
export * from "./StaffListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports